// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"DashboardMenu_menuPaper__1a7Wk","menuList":"DashboardMenu_menuList__2s0Zi","menuItem":"DashboardMenu_menuItem__6alKy"};